import {
  Grid,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableHead,
  Box,
} from '@mui/material';
import {
  DialogContainer,
  DialogBody,
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
} from '../../../../common/components';
import { useExcelExport } from '../../hooks/useExcelExport';
import { usePDFExport } from '../../hooks/usePDFExport';
import StatisticsDialogTitle from '../common/StatisticsDialogTitle';

const ScoreRankingModal = ({ open, handleClose, header, results }) => {
  const { exportToExcel } = useExcelExport();
  const { exportComplexToPDF } = usePDFExport();

  const handleExportToExcel = () => {
    const data = Object.keys(results).flatMap((category) =>
      Object.keys(results[category]).flatMap((group) =>
        results[category][group].map((contract) => ({
          Categoría: category,
          Grupo: group,
          'Número de Contrato': contract.contract_number,
          Suscriptor: contract.subscriber_name,
          'Puntaje Total': contract.total_score,
          Posición: contract.position,
        }))
      )
    );

    exportToExcel(data, 'RankingDePuntajes');
  };

  const handleExportToPDF = () => {
    const sections = Object.keys(results).map((category) => ({
      title: `Categoría: ${category}`,
      data: Object.keys(results[category]).flatMap((group) => [
        `Grupo: ${group}`,
        ...results[category][group].map(
          (contract) =>
            `  ${contract.position}. ${contract.contract_number} - ${contract.subscriber_name} (${contract.total_score} pts)`
        ),
        '', // Espacio entre grupos
      ]),
    }));

    exportComplexToPDF({
      title: 'Reporte de ranking de puntajes',
      sections,
      filename: 'RankingDePuntajes',
      orientation: 'portrait',
    });
  };

  if (!header || !results || Object.keys(results).length === 0) {
    return null;
  }

  return (
    <DialogContainer open={open} onClose={handleClose} size="fullWidth">
      <StatisticsDialogTitle
        title="Ranking de Puntajes"
        onExportExcel={handleExportToExcel}
        onExportPDF={handleExportToPDF}
        onClose={handleClose}
      />
      <DialogBody>
        <Box
          sx={{ mb: 3, textAlign: 'center', border: '1px solid #4a90e2', p: 2, borderRadius: 2 }}
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333', mb: 1 }}>
            {header.constructora_info}
          </Typography>
          <Typography variant="body2" sx={{ color: '#555', fontStyle: 'italic', mb: 0.5 }}>
            Actualizado a la fecha: {header.updated_at_date}
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {Object.keys(results).map((category) =>
            Object.keys(results[category]).map((group) => (
              <Grid item xs={12} md={6} key={`${category}-${group}`}>
                <Card
                  sx={{
                    border: '1px solid #ddd',
                    borderRadius: 2,
                    maxHeight: '350px',
                    overflowY: 'auto',
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      sx={{ fontWeight: 'bold', color: '#333' }}
                    >
                      Categoría: {category}
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      sx={{ fontWeight: 'bold', color: '#555' }}
                    >
                      Grupo: {group}
                    </Typography>

                    <GeneralTableBox>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <HeadTableCell>Posición</HeadTableCell>
                            <HeadTableCell>Orden</HeadTableCell>
                            <HeadTableCell>Suscriptor</HeadTableCell>
                            <HeadTableCell>Puntaje</HeadTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {results[category][group].map((contract, index) => (
                            <TableRow key={index}>
                              <RowTableCell>{contract.position}</RowTableCell>
                              <RowTableCell>{contract.contract_number}</RowTableCell>
                              <RowTableCell>{contract.subscriber_name}</RowTableCell>
                              <RowTableCell>{contract.total_score}</RowTableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </GeneralTableBox>
                  </CardContent>
                </Card>
              </Grid>
            ))
          )}
        </Grid>
      </DialogBody>
    </DialogContainer>
  );
};

export default ScoreRankingModal;
